import React, { useState } from 'react';
import './Search.css';
import searchIcon from '../../../assets/icons/search.svg';

const Search = ({ placeholder = "Поиск новостей...", onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSearch) {
      onSearch(searchTerm);
    }
  };

  return (
    <div className="search-container">
      <form className="search-form" onSubmit={handleSubmit}>
        <div className="search-input-wrapper">
          <div className="search-icon">
            <img src={searchIcon} alt="Поиск" />
          </div>
          <input
            type="text"
            className="search-input"
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </form>
    </div>
  );
};

export default Search;